import { onboardingTasks } from '@/lib/onboardingTasks/tasks';
import type { TaskType } from '@/lib/onboardingTasks/tasks';

export type FirstStatsTaskType = TaskType & { icon: string; duration: number };

export const firstStatsTasks: Record<string, FirstStatsTaskType> = {
    'schedule-post': { ...onboardingTasks['schedule-post'], icon: 'posts', duration: 5 },
    'schedule-report': { ...onboardingTasks['schedule-report'], icon: 'reports-on', duration: 2 },
    'create-group': { ...onboardingTasks['create-group'], icon: 'users-roles-on', duration: 5 },
    'content-inspiration': {
        ...onboardingTasks['content-inspiration'],
        icon: 'magic-wand',
        duration: 2
    }
};
